/**
 * Monaco loader bootstrap. Imported once from main.tsx so it runs before any
 * <Editor /> mounts. Points the loader at our locally-hosted Monaco runtime
 * (copied into public/monaco-editor/vs by scripts/copy-monaco-assets.js)
 * instead of the default cdn.jsdelivr.net URL.
 *
 * Why: the CDN URL fails in Tauri's webview when the user is offline / CDN
 * is blocked / there's a strict CSP — the editor pane just shows a permanent
 * "Loading..." spinner with no useful error. Self-hosting removes the
 * dependency entirely.
 */
import { loader } from '@monaco-editor/react';

let configured = false;

export function configureMonacoLoader(): void {
  if (configured) return;
  configured = true;
  loader.config({
    paths: {
      // Served by Vite from /public at the same origin as the app.
      vs: `${import.meta.env.BASE_URL || '/'}monaco-editor/vs`.replace(/\/+/g, '/'),
    },
  });
}
